import ApiService from "../../../common/api.service";

export async function GetProvinces({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("PROVINCE_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/area/province", option);
    commit("PROVINCE_SUCCESS", _response);
  } catch (error) {
    commit("PROVINCE_ERROR", { result: error.message });
  }
}

export async function GetRegencies({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("REGENCIES_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query(`/v1/area/regency/${option}`, option);
    commit("REGENCIES_SUCCESS", _response);
  } catch (error) {
    commit("REGENCIES_ERROR", { result: error.message });
  }
}

export async function GetDistricts({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("DISTRICTS_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query(`/v1/area/district/${option}`, option);
    commit("DISTRICTS_SUCCESS", _response);
  } catch (error) {
    commit("DISTRICTS_ERROR", { result: error.message });
  }
}
